var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pavilion",attrs:{"role":"link"},on:{"click":_vm.goToPavilion}},[_c('header',[_c('h3',[_vm._v(_vm._s(_vm.pavilion.title))]),_c('div',[_vm._v(_vm._s(_vm.$t('general.enter')))])]),_c('img',{attrs:{"src":_vm.backgroundImageUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }